<template>
    <div class="breadcrum"  :class="{'breadcrumbcss': breadcrumbtheme==='breadcrumbcss'}">
        <nav aria-label="breadcrumb" >
          <ol class="breadcrumb">
            <li class="breadcrumb-item" v-for="bcrumb in breadcrumbdata">
              
              <router-link :to="{path: `${bcrumb.bclink}`}" class="breadcruma" :class="bcrumb.bcactive===true ? 'activelink' : 'nonactive'">
                <div>
                <span>{{ bcrumb.bcgname }}</span>
              </div>
              </router-link>
            </li>
          </ol>
        </nav>

        <!-- :href="`${bcrumb.bclink}`"  -->
      </div>
</template>

<script>

export default {
    props: ['breadcrumbdata', 'breadcrumbtheme']
}

</script>

<style scoped>
nav {
    background-color: white;
    color: #003;

  }
  .breadcruma{
    color: #003;
    z-index: 10;
  }
  .activelink {
    cursor: none;
    font-weight: bold;
    color: maroon;
  }
  .nonactive {
    color: rgb(60, 161, 219);
  }
</style>